import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import intl from "react-intl-universal";
import { formatCurrency } from "../../../Utils/formatters";
import { computeExtractPeriodSummary } from "./extractFilters";

const formatSignedSummary = (value, { positivePrefix = "+" } = {}) => {
  const formatted = formatCurrency(Math.abs(value));
  if (value > 0) return `${positivePrefix}${formatted}`;
  if (value < 0) return `-${formatted}`;
  return formatted;
};

const SummaryMetric = ({ icon: Icon, iconClassName, label, value, valueClassName }) => (
  <div className="extract-period-summary__metric summary-card min-w-0 w-full">
    <div className="flex min-w-0 items-center gap-2">
      <div className={`summary-card-icon ${iconClassName}`}>
        <Icon sx={{ fontSize: 16 }} aria-hidden />
      </div>
      <p
        className="min-w-0 flex-1 truncate text-xs leading-snug text-gray-500 dark:text-gray-400"
        title={label}
      >
        {label}
      </p>
    </div>
    <p className={`mt-2 break-words text-lg font-bold leading-tight tabular-nums sm:text-xl ${valueClassName}`}>
      {value}
    </p>
  </div>
);

export const ExtractPeriodSummary = ({ items = [], className = "" }) => {
  const summary = computeExtractPeriodSummary(items);

  return (
    <div
      className={`extract-period-summary ${className}`}
      role="region"
      aria-label={intl.get("extract.periodSummaryLabel")}
    >
      <SummaryMetric
        icon={ArrowDownward}
        iconClassName="extract-period-summary__icon--credit"
        label={intl.get("extract.totalCredits")}
        value={formatSignedSummary(summary.totalCredits)}
        valueClassName="text-emerald-600 dark:text-emerald-400"
      />
      <SummaryMetric
        icon={ArrowUpward}
        iconClassName="extract-period-summary__icon--debit"
        label={intl.get("extract.totalDebits")}
        value={formatSignedSummary(summary.totalDebits, { positivePrefix: "-" })}
        valueClassName="text-red-600 dark:text-red-400"
      />
    </div>
  );
};
